// Wires the offline search into the data layer:
//   - syncManager rebuilds the MiniSearch index after every data change
//   - apiGet('/api/search-full?term=…') falls back to the worker when offline
import { setIndexBuilder } from "./syncManager";
import { registerSearchFallback } from "./fallbacks";
import { searchClient } from "./searchClient";
import { getRememberedTenant } from "./envStore";

let installed = false;
export function installOfflineSearch() {
  if (installed || !searchClient.isSupported()) return;
  installed = true;
  setIndexBuilder(async ({ tenant, onProgress }) => {
    const off = searchClient.onProgress((p) => onProgress?.({ done: p.done, total: p.total }));
    try {
      return await searchClient.build(tenant);
    } finally {
      off();
    }
  });
  registerSearchFallback((term) => async () => {
    const tenant = getRememberedTenant();
    if (!tenant) return null;
    const st = await searchClient.init(tenant);
    if (st.state !== "fresh") return { documents: [], chunks: [], offlineIndex: st.state };
    const result = await searchClient.search(term);
    return { ...result, offlineIndex: "fresh" };
  });
}
